module.exports = __webpack_public_path__ + "7031846cd1802b15802d69916a431942.svg";